<template>
  <StoreConnectedInputGroup
      class="input-group search__container section__search fuel-utilization__search-bar"
      addon-class="search__button"
      input-class="search__input"
      :store="store"
      :name="name"
      :action="action"
      :icon="icon"
      placeholder="Search...">
  </StoreConnectedInputGroup>
</template>

<script>
  import StoreConnectedInputGroup from './StoreConnectedInputGroup.vue';

  export default {
    name: 'StoreConnectedSearch',
    components: {
      StoreConnectedInputGroup,
    },
    props: {
      store: {
        type: String,
        required: true,
      },
      action: {
        type: String,
        default: 'setProperty',
      },
      name: {
        type: String,
        required: true,
      },
      subProp: {
        default: null,
      },
      field: {
        type: String,
      },
      type: {
        type: String,
        default: 'text',
      },
      icon: {
        type: String,
        default: 'search',
      },
      placeholder: {
        type: String,
        default: '',
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      debounce: {
        type: Boolean,
        default: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
